import { createSelector } from '@ngrx/store';
import { selectUnitById } from 'src/store/generated/unit-record.generated';
import { selectAllVehicleDispositions } from './entity-store-selectors';
import { selectTripByTripId } from './trip-selectors';
import { selectPrimaryVehicleByCardNumber } from './vehicle-selectors';

export function selectVehicleDispositionByVehicleId(vehicleId: string) {
  return createSelector(selectAllVehicleDispositions, (vd) =>
    vd.find((v) => v.vehicleId === vehicleId),
  );
}

export function selectVehicleDispositionByCurrentWaypointId(waypointId: string) {
  return createSelector(selectAllVehicleDispositions, (vd) =>
    vd.find((v) => v.currentWaypointId === waypointId && v.dateDeleted == null),
  );
}

export function selectVehicleDispositionByTripId(tripId: string) {
  return createSelector(selectTripByTripId(tripId), selectAllVehicleDispositions, (trip, vd) => {
    return trip != null ? vd.find((v) => v.vehicleId === trip.vehicleId) : undefined;
  });
}

export function selectVehicleDispositionByUnitId(unitId: string) {
  return createSelector(
    selectUnitById(unitId),
    selectAllVehicleDispositions,
    (unit, dispositions) => {
      const result =
        unit != null ? dispositions.find((d) => d.vehicleId === unit.vehicleId) : undefined;
      return result;
    },
  );
}

export function selectVehicleDispositionByCardNumber(cardNumber: string) {
  return createSelector(
    selectPrimaryVehicleByCardNumber(cardNumber),
    selectAllVehicleDispositions,
    (vehicle, vehicleDispositions) => {
      return vehicle == null
        ? undefined
        : vehicleDispositions.find((vd) => vd.vehicleId === vehicle.id);
    },
  );
}

export function selectVehicleDispositionsByVehicleIds(vehicleIds: string[]) {
  return createSelector(selectAllVehicleDispositions, (vehicleDispositions) => {
    return vehicleDispositions.valueSeq().filter((vd) => vehicleIds.includes(vd.vehicleId));
  });
}
